import React, { useEffect } from "react";
import { useDrop } from "react-dnd";
import PropTypes from "prop-types";

const ItemTypes = {
  ASSET: "asset"
};

const handleDrop = (items, scene, userName, sessionId) => {
  const entries = items.map((item, index) => {
    return {
      ...item,
      type: "media",
      url: item.url,
      thumbnail: item.thumbnail,
      index
    };
  });

  entries.forEach(entry => {
    scene.emit("action_selected_media_result_entry", {
      entry,
      selectAction: "spawn"
    });
  });

  setTimeout(() => {
    window.APP.messageDispatch.push(
      {
        sender: userName,
        senderSessionId: sessionId
      },
      "object"
    );
  }, 1000);
};

const DropArea = ({ scene, userName, sessionId }) => {
  const [isDragging, setIsDragging] = React.useState(false);

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ItemTypes.ASSET,
    drop: item => {
      const droppedItems = item.selectedItems;
      // Dummy function on drop
      handleDrop(droppedItems, scene, userName, sessionId);
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  });

  useEffect(() => {
    const handleDragStart = () => {
      setIsDragging(true);
    };

    const handleDragEnd = () => {
      setTimeout(() => {
        setIsDragging(false);
      }, 100);
    };

    window.addEventListener("dragstart", handleDragStart);
    window.addEventListener("dragend", handleDragEnd);

    return () => {
      window.removeEventListener("dragstart", handleDragStart);
      window.removeEventListener("dragend", handleDragEnd);
    };
  }, []);

  const isActive = isOver && canDrop;
  const backgroundColor = isActive ? "rgba(0, 0, 0, 0.1)" : "transparent";

  if (!isDragging) {
    return null;
  }

  return (
    <div
      ref={drop}
      id="droparea"
      style={{
        height: "100vh",
        flex: 1,
        border: "2px dashed var(--primary-color)",
        backgroundColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    ></div>
  );
};

DropArea.propTypes = {
  scene: PropTypes.object.isRequired,
  userName: PropTypes.string,
  sessionId: PropTypes.string
};

export default DropArea;
